export default class ModalOKCSS {

  static typeSuccess = "border-4 border-green-500"
  static typeInfo = "border-4 border-black-500"
  static typeWarning = "border-4 border-orange-500"
  static typeError: "border-4 border-red-500"
}